import { render, staticRenderFns } from "./ProjectSmallCard.vue?vue&type=template&id=68e34de6&scoped=true"
import script from "./ProjectSmallCard.vue?vue&type=script&lang=js"
export * from "./ProjectSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e34de6",
  null
  
)

export default component.exports